import React, { useState } from 'react';
import { ISalesInfoGraphPopupProps, IManualInputContextProps } from './ContextProps';

export const ManualInputContext = React.createContext<IManualInputContextProps>({} as IManualInputContextProps);

export function ManualInputProvider({ children }: any) {
  const [isGraphPopupShown, setIsGraphPopupShown] = useState<boolean>(false);
  const [graphPopupData, setGraphPopupData] = useState<ISalesInfoGraphPopupProps>({
    maxMarketSharePotential: 0,
    maxTotalSales: 0,
    bar1Data: {
      totalMarketSharePotential: 0,
      totalSales: 0,
      year : 0,
      quarter : 0
    },
    bar2Data: {
      totalMarketSharePotential: 0,
      totalSales: 0,
      year : 0,
      quarter : 0
    },
    bar3Data: {
      totalMarketSharePotential: 0,
      totalSales: 0,
      year : 0,
      quarter : 0
    },
    bar4Data: {
      totalMarketSharePotential: 0,
      totalSales: 0,
      year: 0,
      quarter : 0
    },
    product: '',
    productCategory: ''
  });

  function showGraphPopupWithData(data: ISalesInfoGraphPopupProps) {
    setIsGraphPopupShown(true);
    setGraphPopupData(data);
  }

  function toggleGraphPopup () {
    setIsGraphPopupShown(!graphPopupData);
  }

  return (
    <ManualInputContext.Provider value={{isGraphPopupShown, graphPopupData, showGraphPopupWithData, toggleGraphPopup}}>
      {children}
    </ManualInputContext.Provider>
  )
}
